module.exports = __webpack_public_path__ + "static/img/central.187b175.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/central.png
// module id = 30R6
// module chunks = 1